import { useQuery } from '@tanstack/react-query';

import { useQuizStatsFilters } from '@/hooks';
import { sdk } from '@/services';
const QuizResultService = sdk.getService('QuizResultService');

export const useMyQuizzesProgress = () => {
  const { dateFilter } = useQuizStatsFilters();
  const queryKey = ['quiz-results', 'progress', 'me', dateFilter];
  const { data, isLoading } = useQuery({
    queryKey,
    queryFn: () => QuizResultService.getUserProgress(dateFilter)
  });

  return {
    isLoading,
    quizzesProgress: data
  };
};
